module.exports = __webpack_public_path__ + "static/img/6317_phase_function_Paper_PointsHejduk_Prediction.7ce3d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6317_phase_function_Paper_PointsHejduk_Prediction.png
// module id = IkoQ
// module chunks = 0